import { Skeleton } from "@/ui/components/ui/skeleton";

/** Loading placeholder shared by both taxonomy tabs. */
export const TaxonomyTabSkeleton = () => (
  <div className="space-y-6">
    <Skeleton className="h-20 w-full" />
    <Skeleton className="h-40 w-full" />
    <Skeleton className="h-64 w-full" />
  </div>
);

export default TaxonomyTabSkeleton;
